import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class GradPlanModel {
	catalog_id: number;
	catalog_title: string;
	@Transform(dateTransformer)
	creation_date: Date;
	@Transform(dateTransformer)
	deactivation_date: Date;
	endorsement: string;
	id: number;
	@Transform(dateTransformer)
	last_edited_date: Date;
	title: string;
}
